import { Card, Grid, Text, Title } from '@mantine/core';
import { IconList } from '@tabler/icons-react';

const GeneratedLandingTypeCard = ({ option, type, selectType }) => {
  const isSelected = option.value === type;

  return (
    <Grid.Col span={{ base: 12, md: 4 }} className="generatedLandingCardContainer" mb="lg">
      <Card
        withBorder
        className={`subscription-card ${isSelected ? 'subscription-card-selected' : ''}`}
        onClick={() => selectType(option)}
        padding="md"
        style={{ cursor: 'pointer', height: '100%' }}
      >
        <Title order={3} ta="left" mb={option.description ? undefined : 0}>
          {option.tablerIcon || <IconList size={16} />} {option.label}
        </Title>
        {option.description && (
          <Text c="dimmed" mb={0}>
            {option.description}
          </Text>
        )}
      </Card>
    </Grid.Col>
  );
};

export default GeneratedLandingTypeCard;
